import { useState } from "react";
import { Modal } from "../components/Modal";
import { ArrowUpRight, FileText } from "lucide-react";

export default function IssueDialog({ indent, onClose, onSubmit }) {
  const today = new Date().toISOString().slice(0, 10);
  const [form, setForm] = useState({
    delivered_by: "Store In-charge",
    delivered_date: today,
    received_by: indent?.raised_by || "",
    received_date: today,
    remarks: "",
  });
  const [busy, setBusy] = useState(false);

  const update = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await onSubmit(indent.id, form);
    } finally {
      setBusy(false);
    }
  };

  const openPdf = () => {
    if (!indent.upload_data) return;
    const win = window.open();
    if (win) win.document.write(`<iframe src="${indent.upload_data}" style="border:0;width:100%;height:100vh"></iframe>`);
  };

  return (
    <Modal title={`Issue ${indent.id}`} subtitle="ISSUE & DELIVER" onClose={onClose}>
      <div className="indent-summary">
        <div>
          <p className="eyebrow">DEPARTMENT</p>
          <strong>{indent.department}</strong>
          <span>{indent.raised_by} · {indent.raised_by_role}</span>
        </div>
        <div>
          <p className="eyebrow">INDENT DATE</p>
          <strong>{indent.indent_date}</strong>
          <span>Issue: {indent.issue_date}</span>
        </div>
        {indent.upload_name && (
          <button type="button" className="secondary sm" data-testid="view-pdf-button" onClick={openPdf}>
            <FileText size={14} /> View PDF
          </button>
        )}
      </div>

      <div className="units-block">
        <p className="eyebrow">LINE ITEMS</p>
        <div className="unit-rows">
          {(indent.items || []).map((l, i) => (
            <div className="line-row summary-line" key={i}>
              <strong>{l.name}</strong>
              <span>{l.qty} {l.unit}</span>
              {l.batch && <span className="mono">Batch {l.batch}</span>}
            </div>
          ))}
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="form-grid">
          <label>Delivered by (Store)
            <input data-testid="delivered_by-input" value={form.delivered_by} onChange={(e) => update("delivered_by", e.target.value)} required />
          </label>
          <label>Delivered date
            <input data-testid="delivered_date-input" type="date" value={form.delivered_date} onChange={(e) => update("delivered_date", e.target.value)} required />
          </label>
          <label>Received by (Department)
            <input data-testid="received_by-input" value={form.received_by} onChange={(e) => update("received_by", e.target.value)} required />
          </label>
          <label>Received date
            <input data-testid="received_date-input" type="date" value={form.received_date} onChange={(e) => update("received_date", e.target.value)} required />
          </label>
          <label className="full">Remarks / signature note
            <textarea data-testid="remarks-input" rows={2} value={form.remarks} onChange={(e) => update("remarks", e.target.value)} placeholder="Signed by names above. Add any handover notes." />
          </label>
        </div>
        <div className="modal-actions">
          <button type="button" className="secondary" onClick={onClose}>Cancel</button>
          <button className="primary" data-testid="issue-submit-button" disabled={busy}>
            {busy ? "Issuing…" : "Confirm issue"} <ArrowUpRight size={16} />
          </button>
        </div>
      </form>
    </Modal>
  );
}
